import type { StoreType } from '@gozoki/api-types'

export const getStoreTypeLabel = (storeType: StoreType) => {
  switch (storeType) {
    case 'BOUTIQUE': {
      return 'Boutique'
    }
    case 'SHIPPING': {
      return 'Transport'
    }
    case 'WAREHOUSE': {
      return 'Entrepot'
    }
    case 'POUBELLE': {
      return 'Poubelle'
    }
    case 'INTERNAL_STOCK': {
      return 'Stock interne'
    }
    default: {
      return 'Store Type inconu !'
    }
  }
}

export const getInventoryStatusLabel = (status: string): string => {
  switch (status) {
    case 'validated': {
      return 'Validé'
    }
    case 'pending': {
      return 'En cours'
    }
    case 'canceled': {
      return 'Annulé'
    }
    default: {
      return status
    }
  }
}
